import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconWhiteboard2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="whiteboard-2"><path d="M20.25 4.75V19.25M20.25 4.75H12.0002M20.25 4.75H21.25M20.25 19.25H3.75M20.25 19.25H21.25M3.75 19.25V4.75M3.75 19.25H2.75M3.75 4.75H12.0002M3.75 4.75H2.75M12.0002 4.75V3.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconWhiteboard2;
